<div
  *ngIf="shouldShow()"
  class="px-2 pb-4 lh-sm"
  [innerHTML]="text()"
  data-testid="personal-data-message"
></div>
